module.exports = __webpack_public_path__ + "img/zsgl.a3de26ea.svg";